import { StubTab } from './_StubTab';
export default function CrossSellTab(props) {
  return <StubTab title="Cross-Sell" phase="D" hint="Per-opportunity status (Tax Prep, Tax Plan, Financial Planning, Insurance, AUM Expansion) + next-action date + notes. Backed by the cross_sell_opportunities table created in Phase A. Replaces the standalone Excel tracker." {...props} />;
}
